import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import OverlayDropdownButton from "components/common/OverlayDropdownButton";
import { MenuItem } from "components/bootstrap";
import { HoverForHelp, Icon } from "components/common";
import FilterConfiguration from "components/common/EntityFilters/FilterConfiguration";
const Container = styled.div`
  margin-left: 5px;
`;
const AttributeSelect = ({
  attributes,
  setSelectedAttributeId,
  activeFilters
}) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { header: true }, t("filters.create_filter")), attributes.map(({ id, title, type, single_filter }) => {
    var _a;
    const hasActiveFilter = !!((_a = activeFilters == null ? void 0 : activeFilters.get(id)) == null ? void 0 : _a.length);
    const disabled = (type === "BOOLEAN" || !!single_filter) && hasActiveFilter;
    return /* @__PURE__ */ React.createElement(MenuItem, { onSelect: () => setSelectedAttributeId(id), key: `${title}-filter`, disabled }, title, disabled && /* @__PURE__ */ React.createElement(HoverForHelp, { displayLeftMargin: true }, t("filters.single_filter_only"), /* @__PURE__ */ React.createElement("br", null), t("filters.update_existing")));
  }));
};
const CreateFilterDropdown = ({ filterableAttributes, filterValueRenderers, onCreateFilter, activeFilters }) => {
  const { t } = useTranslation("common");
  const [selectedAttributeId, setSelectedAttributeId] = useState();
  const selectedAttribute = filterableAttributes.find(({ id }) => id === selectedAttributeId);
  const onToggleDropdown = () => setSelectedAttributeId(void 0);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    OverlayDropdownButton,
    {
      title: /* @__PURE__ */ React.createElement(Icon, { name: "add" }),
      bsSize: "small",
      buttonTitle: t("filters.create_filter"),
      onToggle: onToggleDropdown,
      closeOnSelect: false,
      dropdownZIndex: 1050
    },
    ({ toggleDropdown }) => {
      const _onCreateFilter = (filter, closeDropdown = true) => {
        if (closeDropdown || (selectedAttribute == null ? void 0 : selectedAttribute.single_filter)) {
          toggleDropdown();
        }
        onCreateFilter(selectedAttributeId, { value: filter.value, title: filter.title });
      };
      if (!selectedAttributeId) {
        return /* @__PURE__ */ React.createElement(
          AttributeSelect,
          {
            attributes: filterableAttributes,
            setSelectedAttributeId,
            activeFilters
          }
        );
      }
      return /* @__PURE__ */ React.createElement(
        FilterConfiguration,
        {
          onSubmit: _onCreateFilter,
          allActiveFilters: activeFilters,
          attribute: selectedAttribute,
          filterValueRenderer: filterValueRenderers == null ? void 0 : filterValueRenderers[selectedAttributeId]
        }
      );
    }
  ));
};
export default CreateFilterDropdown;
